module.exports = __webpack_public_path__ + "static/media/matt_knight.f172fab2.jpg";